<script lang="ts">
    import LastmileFilter from '../../shared/LastmileFilter.svelte';
    import { filter } from '../../../stores/filter';
    import { api, connections_filter_config } from '../../../stores/api';
    import { get } from 'svelte/store';
    import { CustomFilterManagerIO } from '../../utilities/FilterManagerIO';
    import { routes } from '../../../stores/store';

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let makeBlured: boolean = false;

    let filterManagerIO = new CustomFilterManagerIO(
        get(api),
        $filter.connections.managerStorageKey
    );

    let filterComponent: any = null;

    $: {
        if ($routes.forceReloadFilter) {
            $routes.forceReloadFilter = false;
            console.log('JobListFilter forceReload');
            filterManagerIO.load();
            filterManagerIO = filterManagerIO;
            if (filterComponent) {
                filterComponent.updateFilters($filter.connections.queries);
            }
        } else {
            console.log('JobListFilter no forceReload');
        }
    }

    //         filterManagerStorageKey={$filter.connections.managerStorageKey}
</script>

{#if $connections_filter_config}
    <LastmileFilter
        collectionName="connections"
        onChange={queries => {
            $filter.connections.queries = queries;
        }}
        bind:this={filterComponent}
        showQuickFilters={false}
        {filterManagerIO}
        filterConfig={$connections_filter_config}
        enableInactiveQueries={true}
        {filteredCount}
        {totalCount}
        {makeBlured}
    />
{/if}
